import React, { useEffect, useState } from 'react';
import { useSecurityStatus } from '../../hooks/security';
import { getUser } from '../../services/auth';
import { FixedPanel } from './FixedPanel';
import { handleError } from './Functions';
import { PrivacyFooter } from './PrivacyFooter';
import CloseIcon from '@mui/icons-material/Close';

export const OffCanvasPanel = ({sidePanel, setSidePanel, logout, tertiary, fail}) => {
    let auth = useSecurityStatus();
    let [loading, setLoading] = useState(true);
    let [user, setUser] = useState<any>({});

    useEffect(() => {
        if (loading && auth.authed) {
            getUser()
                .then(u => {
                    setUser(u);
                    setLoading(false);
                }).catch(err => err.message !=="Not Found" && fail(handleError(err)))

        }
    }, [loading, auth.authed])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={"navbar-collapse " + sidePanel}>
            <div className="offcanvas-inner">
                <div className="panel-user-profile">
                    <CloseIcon type="button"
                        onClick={e => setSidePanel("offcanvas-collapse")}
                        className="close offcanvas-close"
                        aria-label="Close" />
                    <div style={{ marginTop: "50px", marginBottom: "50px", textAlign: "center" }}>
                        <div><b>{user.name}</b></div>
                        <div className="text-muted">{user.email}</div>
                    </div>
                </div>
                <FixedPanel setSidePanel={setSidePanel} logout={logout} tertiary={tertiary} />
                <PrivacyFooter />
            </div>
        </div>)
}
